import { useState } from "react";
import _ from "lodash";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ProcessDesignerToolbar from "./ProcessDesignerToolbar";
import ProcessDesignerModal from "./ProcessDesignerModal";
import ComponentEntity from "../Component/ComponentEntity";

//import { MdAdd } from "react-icons/md";
import { getLabel } from "../../tools/Dictionary";

/*
Used by ProcessDesignerSchema
*/

const ProcessDesignerDetail = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const Step = props.Step;
  const Component = props.Component;
  const ComponentAction = props.ComponentAction;
  const OnClickHome = props.OnClickHome;
  const OnClickPrevious = props.OnClickPrevious;
  const OnUpdateStep = props.OnUpdateStep;
  const OnConfirm = props.OnConfirm;
  const OnDeleteComponent = props.OnDeleteComponent;
  const OnMoveComponent = props.OnMoveComponent;
  const TempId = props.TempId;
  const IncrementTempId = props.IncrementTempId;
  const OnDeleteStep = props.OnDeleteStep;

  //State
  const [loading] = useState(false);
  const [modal, setModal] = useState({
    display: false,
    id: 0
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  const onEditStep = (_step) => {

    OnUpdateStep(_step);

  };

  const onAddComponent = (_component, _position = 0) => {

    try{

      //Generate a name for the component
      let incName = 1; //Incremental number to complet name
      let name = ""; // hold tentative name
      let nameExist = true; // Stay true if name already exists

      //Loop until name doesn't exists
      while (nameExist)
      {

        //Try a name
        let tempName = _component.code + "_" + incName.toString();


        //Check if it exists
        nameExist = Step.component.some(c =>
        {
          //If exists return true
          if (c.name == tempName)
            return true;
          //Doesn't exists
          return false;

        });

        name = tempName;

        incName++;

      }

      let tempStep = _.cloneDeep(Step);
      let tempComponent = _.cloneDeep(_component);

      tempComponent.name = name;
      tempComponent._id = TempId;

      tempStep.component.push(tempComponent);

      OnUpdateStep(tempStep);
      IncrementTempId();


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

    
  };

  const onClickEditComponent = (_id) => {

    setModal({
      display:true,
      id: _id
    });

  }



  const onMoveComponent = (_componentId, _position) =>
  {
    try{

      OnMoveComponent(Step._id, _componentId, _position);

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }
    
  }

  const onClickDelete = (_componentId) => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("ProcessDesignerDetail", "Are you sure you want to delete this component"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onDelete(Step._id, _componentId),
      Display: true
    }));



  };

  const onDelete = (_stepId, _componentId) => {

    try{

      setConfirm(confirm => ({ ...confirm, Display: false }));

      OnDeleteComponent(_stepId, _componentId);

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };

  };



  const onClickContext = (e) =>
  {
    e.stopPropagation();
  };


  if (!Step || !Step.component) return null;


  return (
    <div className="processdesigner_detail_cont" onContextMenu={onClickContext}>
      <ProcessDesignerToolbar 
        Access={Access}
        ReadOnly={ReadOnly}
        IsDesktop={IsDesktop}
        OnClickHome={OnClickHome}
        OnClickPrevious={OnClickPrevious}
        Component={Component}
        Step={Step}
        OnAddComponent={onAddComponent}
        OnEditStep={onEditStep}
        OnDeleteStep={OnDeleteStep}
      />
      {modal.display &&
        <ProcessDesignerModal
          IsDesktop={IsDesktop}
          Access={Access}
          ReadOnly={ReadOnly}
          Data={Step.component.find(c => c._id == modal.id)}
          Step={Step}
          ComponentAction={ComponentAction}
          OnCloseModal={() => setModal({display: false, id: 0})}
          OnConfirm={OnConfirm}
        />
      }
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      <div className="processdesigner_detail_title_cont">
        {getLabel("ProcessDesigner", "Step title")} : &nbsp;<span>{Step.title}</span>
      </div>
      <div className="processdesigner_detail_component_cont">

        {Step.component.map((c, index) => (
          <ComponentEntity 
            key={index}
            IsDesktop={IsDesktop}
            Access={Access}
            ReadOnly={ReadOnly}
            Edit={true}
            Data={c}
            OnClickEdit={onClickEditComponent}
            OnClickDelete={onClickDelete}
            OnClickMove={onMoveComponent}
          />
        ))}
      </div>
    </div>
  );

};

export default ProcessDesignerDetail